
export default () => {
  apos.util.widgetPlayers.benefitSection = {
    selector: '.benefits-section.layout-grid',
    player: function (benefitWidget) {
      if (benefitWidget) {
        const CARD_SELECTOR = '.benefits__cards__card-item';
        const CARD_DESCRIPTION_SELECTOR = `${CARD_SELECTOR}__description`;
        const CARD_DESCRIPTION_TEXT_SELECTOR = `${CARD_SELECTOR}__description__text`;
        const CARD_SEE_MORE_LINK_SELECTOR = `${CARD_SELECTOR}__description__see-more`;

        if (!isInEditorMode()) {
          setHeightOfCards();
          addEventListenerToElements(benefitWidget, CARD_SELECTOR, 'mouseleave', resetCardState);
          addEventListenerToElements(benefitWidget, CARD_SEE_MORE_LINK_SELECTOR, 'click', setOverflowY);
        }

        function addEventListenerToElements(root, selector, event, action) {
          root.querySelectorAll(selector).forEach(elem => elem.addEventListener(event, action));
        }

        function resetCardState(event) {
          const card = event.target;
          const isScrollable = Boolean(card.dataset.scrollable);
          const cardDescription = card.querySelector(CARD_DESCRIPTION_SELECTOR);

          if (isScrollable) {
            cardDescription.scrollTop = 0;
            cardDescription.scrollLeft = 0;
            cardDescription.style.overflowY = 'hidden';
            card.querySelector(CARD_SEE_MORE_LINK_SELECTOR).style.display = 'block';
          }
        }

        function setOverflowY(event) {
          const card = event.target.parentElement.parentElement;

          card.querySelector(CARD_DESCRIPTION_SELECTOR).style.overflowY = 'scroll';
          card.querySelector(CARD_SEE_MORE_LINK_SELECTOR).style.display = 'none';
        }

        function setHeightOfCards() {
          const cards = benefitWidget.querySelectorAll(CARD_SELECTOR);
          const cardsTextContainer = cards[0].querySelector(CARD_DESCRIPTION_SELECTOR);
          const cardsText = cardsTextContainer.querySelector(CARD_DESCRIPTION_TEXT_SELECTOR);
          const height = cardsTextContainer.offsetHeight;
          const lineHeight = parseFloat(window.getComputedStyle(cardsText)?.getPropertyValue('line-height'));
          const newHeight = Math.floor(height/lineHeight) * lineHeight;

          cards.forEach(card => {
            const textContainer = card.querySelector(CARD_DESCRIPTION_SELECTOR);
            const text = card.querySelector(CARD_DESCRIPTION_TEXT_SELECTOR);
            const isScrollable = text.offsetHeight > newHeight;

            if (isScrollable) {
              card.dataset.scrollable = 'true';
              card.querySelector(CARD_SEE_MORE_LINK_SELECTOR).style.display = 'block';
            } else {
              card.querySelector(CARD_SEE_MORE_LINK_SELECTOR).style.display = 'none';
            }

            textContainer.style.height = `${newHeight}px`;
            text.style.height = `${newHeight}px`;
          });
        }

        function isInEditorMode() {
          return document.querySelector('.apos-area-widget-inner');
        }
      }
    }
  };
};
